import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";

export function usePendingInvoicesCount(enabled = true) {
  return useQuery({
    queryKey: ["invoices-pending-count"],
    queryFn: () =>
      apiClient
        .get<{ data: number }>("/invoices/pending-count/")
        .then((r) => r.data.data),
    enabled,
  });
}

export function usePrzDraftCount(enabled = true) {
  return useQuery({
    queryKey: ["prz-draft-count"],
    queryFn: () =>
      apiClient
        .get<{ data: { count: number } }>("/notifications/prz-draft-count/")
        .then((r) => r.data.data.count),
    enabled,
  });
}

export function usePrzInvestorCount(enabled = true) {
  return useQuery({
    queryKey: ["prz-investor-count"],
    queryFn: () =>
      apiClient
        .get<{ data: { count: number } }>("/notifications/prz-investor-count/")
        .then((r) => r.data.data.count),
    enabled,
  });
}

export function useInvoicesNeedsActionCount(enabled = true) {
  return useQuery({
    queryKey: ["invoices-needs-action-count"],
    queryFn: () =>
      apiClient
        .get<{ data: number }>("/invoices/needs-action-count/")
        .then((r) => r.data.data),
    enabled,
  });
}

export function usePrzNeedsApprovalCount(enabled = true) {
  return useQuery({
    queryKey: ["prz-needs-approval-count"],
    queryFn: () =>
      apiClient
        .get<{ data: { count: number } }>("/finances/client-invoices/unapproved-count/")
        .then((r) => r.data.data.count),
    enabled,
  });
}

export function usePrzProformaToConvertCount(enabled = true) {
  return useQuery({
    queryKey: ["prz-proforma-to-convert-count"],
    queryFn: () =>
      apiClient
        .get<{ data: { count: number } }>("/notifications/prz-proforma-to-convert-count/")
        .then((r) => r.data.data.count),
    enabled,
    staleTime: 30_000,
  });
}
